
import InstantMessageController from 'controller/InstantMessageController'
import { adjustMessageData } from 'service/extension/messaging'

const processWhatsAppMessageReceivedCommand = (command) =>
{
  const msg = adjustMessageData(command.Message)
  const conversation = InstantMessageController.Conversations.get(msg.uid || msg.wa_id)

  if (conversation)
  {
    // already have this customer info
    conversation.messages.unshift(msg)
  }
  else 
  {
    const newConversation = InstantMessageController.initConversation(msg)
    newConversation.messages.push(msg)
    InstantMessageController.loadCustomer(msg.uid)
  }

}

//--------------------------------------------------------------------------
export const processCommand = (command) =>
{
  const fn_commandExecutor = {
    'WhatsAppMessageReceived': processWhatsAppMessageReceivedCommand
  }[command.Type]

  if (!fn_commandExecutor)
  {
    throw Error(`WS command type [${command.Type}] is not defined.`)
  }

  fn_commandExecutor(command)
}

